<template>
  <div class="product-details">
    <draft-card
      v-if="['draft', 'in_review'].includes(product.status)"
      class="mb-5"
      :product="product"
      :enable="enableApprovalRequest"
    />

    <div class="cards-row">
      <feature-card
        v-for="(option, i) in options"
        :key="i"
        :icon="option.icon"
        :color="option.color"
        :title="option.title"
        :subtitle="option.subtitle"
        @click="selectOption(option)"
      />
    </div>

    <responsive-modal v-model="modal.checkin">
      <event-checkin-modal
        @success="modal.checkin = false"
        @repeated-code="modal.checkin = false"
        @close="modal.checkin = false"
      />
    </responsive-modal>
  </div>
</template>

<script>
import { approvalMessageUrl } from "@/functions/product";
import ProductDetailsMixin from "@/mixins/productDetails";

import EventCheckinModal from "@/components/events/EventCheckinModal.vue";
import FeatureCard from "@/components/FeatureCard.vue";
import DraftCard from "@/components/product/details/DraftCard.vue";

export default {
  components: { EventCheckinModal, DraftCard, FeatureCard },
  mixins: [ProductDetailsMixin],
  data() {
    return {
      modal: {
        checkin: false
      }
    };
  },
  methods: {
    approvalMessageUrl,
    selectOption(option) {
      if (option.route) {
        const params = { id: this.$route.params.id, ...option.params };
        this.$router.push({ name: option.route, params });
      } else if (option.modal) this.modal[option.modal] = true;
    },
    getScopeColor(option) {
      const scope = this.scopes.find(scope => scope.options.includes(option));
      return scope ? scope.color : "";
    }
  },
  computed: {
    enableApprovalRequest() {
      return !!this.product.checkout_build;
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details {
  .cards-row {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
    gap: 28px;

    button {
      appearance: none;
      -webkit-appearance: none;
      background-color: transparent;
      display: flex;
      text-align: left;
      align-items: center;
      padding: 24px;
      border-radius: 16px;
      border: none;
      background: var(--bg-2);
      transition: background-color 0.2s;
      line-height: 1;
      &:hover {
        background-color: var(--bg-3);
      }
      h4 {
        line-height: 20px;
      }
      span {
        line-height: 16px;
      }
    }
  }
}
</style>
